import { UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { TTheme } from '../../types/page/theme';

interface IPromoBannerLayoutProps {
  heading: string;
  title: string;
  theme: TTheme;
  background: React.ReactNode;
  buttons: React.ReactNode;
  mainButtonsRef?: React.Ref<HTMLDivElement>;
}

export const PromoBannerLayout: React.FC<IPromoBannerLayoutProps> = ({
  heading,
  title,
  theme,
  background,
  buttons,
  mainButtonsRef,
}) => {
  return (
    <div data-testid="PromoBannerContainer" className={cn(style['container'], style[theme])}>
      <div className={style['wrapper']}>
        <div className={style['title']}>
          <h1>{heading}</h1>
          <UIText2 color="text-primary-default">{title}</UIText2>

          <div className={style['buttons']} ref={mainButtonsRef}>
            {buttons}
          </div>
        </div>

        <div className={style['bg-image']}>{background}</div>
      </div>
    </div>
  );
};
